import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { Shell } from '@app/shell/shell.service';
import { canActivate } from '@shared/auth/auth-guard';

const routes: Routes = [
  Shell.childRoutes([
    {
      path: 'candc',
      loadChildren: () => import('./active-checkin/active-checkin.module').then((m) => m.ActiveCheckinModule),
      canActivate: [canActivate],
    },
    {
      path: 'devices',
      loadChildren: () => import('./alarm-plans/alarm-plans.module').then((m) => m.AlarmPlansModule),
      canActivate: [canActivate],
    },
  ]),
  // Fallback when no prior route is matched
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
